module.exports = __webpack_public_path__ + "static/media/FormIt.302cdfbb.png";